const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bill Notification") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M118,344.556V199.027c0-9.806,8.479-18.027,18.286-18.027h-20C106.479,181,98,189.221,98,199.027V344.556l84,51.334,10-6.112Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,307.888v-7.555a9.046,9.046,0,0,1,4.288-7.668L86,278.294V266.173L42.288,292.665A9.046,9.046,0,0,0,38,300.333v7.555l48,29.334V325Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,446.254v-112.1l-20-12.2v124.3A28.152,28.152,0,0,0,65.833,474h20A28.152,28.152,0,0,1,58,446.254Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,166.778V61.527A23.929,23.929,0,0,1,288.614,38h-20A23.929,23.929,0,0,0,245,61.527V166.778C245,179.523,255.869,190,268.614,190h20C275.869,190,265,179.523,265,166.778Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.167,486C320.855,486,338,467.942,338,446.254V300.333a20.886,20.886,0,0,0-9.777-17.905l-48.886-30.245c-.2-.124-.6-.237-.813-.336L278,251.69v-4.8a5.785,5.785,0,0,0-1.284-4.007l-64.027-71.518c-.042-.046-.031-.081-.074-.126a6.036,6.036,0,0,0-4.432-2.137c-.2,0-.371-.106-.568-.106H116.286C99.862,169,86,182.6,86,199.027v53.114L36.05,282.414A21.128,21.128,0,0,0,26,300.333V446.254C26,467.942,44.145,486,65.833,486Zm22.526-193.346A9.053,9.053,0,0,1,326,300.333v7.555l-48,29.334V265.69ZM214,190.9,252.45,234H232c-9.807,0-18-8.451-18-18.258ZM116.286,181H202v34.742C202,232.166,215.576,246,232,246h31.214L266,249.19v95.366L182,395.89,98,344.556V199.027C98,189.221,106.479,181,116.286,181Zm-74,111.665L86,266.173v71.049L38,307.888v-7.555A9.046,9.046,0,0,1,42.288,292.665ZM38,446.254v-124.3l141.121,86.088a6.438,6.438,0,0,0,3.254.88,5.365,5.365,0,0,0,2.941-.88L326,321.953v124.3C326,461.325,314.238,474,299.167,474H65.833A28.152,28.152,0,0,1,38,446.254Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.577,306.787l-17.013-.183a6,6,0,0,0-4.231,10.317l42.089,40.637a6,6,0,1,0,8.335-8.633L167.52,318.766l1.928.021a31.59,31.59,0,0,0,31.21-25.043l11.5.256h.066a6.1,6.1,0,0,0,.063-12.2l-11.5-.157a31.654,31.654,0,0,0-6.056-13.7l17.705.06h.065a5.916,5.916,0,1,0,.063-11.831l-42.44-.427-17.012-.168a6.005,6.005,0,0,0-.129,12.01l17.012.185a19.543,19.543,0,0,1,18.414,13.66L152.838,281h-.066a6.037,6.037,0,0,0-.063,12.073l35.571.393a19.5,19.5,0,0,1-18.7,13.321Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.443,85H346.5a6,6,0,0,0,0-12H282.443a6,6,0,0,0,0,12Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.557,73H381.431a6,6,0,0,0,0,12h55.126a6,6,0,0,0,0-12Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.607,115a6,6,0,0,0-6-6H282.443a6,6,0,0,0,0,12H385.607A6,6,0,0,0,391.607,115Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.557,109H420.544a6,6,0,0,0,0,12h16.013a6,6,0,0,0,0-12Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.317,145H282.443a6,6,0,0,0,0,12h69.874a6,6,0,0,0,0-12Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.557,145h-49.3a6,6,0,0,0,0,12h49.3a6,6,0,0,0,0-12Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.386,26H268.614C249.252,26,233,42.165,233,61.527V166.778C233,186.141,249.252,202,268.614,202H308v32.051a6.008,6.008,0,0,0,6.006,6,5.941,5.941,0,0,0,3.424-1.018L370.837,202h79.549C469.748,202,485,186.141,485,166.778V61.527C485,42.165,469.748,26,450.386,26ZM473,166.778C473,179.523,463.131,190,450.386,190H368.958a5.964,5.964,0,0,0-3.427,1.018L320,222.579V195.893A5.9,5.9,0,0,0,314.009,190h-45.4C255.869,190,245,179.523,245,166.778V61.527A23.929,23.929,0,0,1,268.614,38H450.386C463.131,38,473,48.782,473,61.527Z",
    style: {
      fill: "#2eca8b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket3);
export default __webpack_public_path__ + "static/media/ticket3.c6fb7785c604ce43a6cbf1c858b62997.svg";
export { ForwardRef as ReactComponent };